import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceNewLine'
})
export class ReplaceNewLinePipe implements PipeTransform {

  transform(value: string | null | undefined): string {
    if (!value) return '';

    return value
      // 1️⃣ converte \\n ou \n em quebra de linha real
      .replace(/(\\n)/g, '\n')
      // 2️⃣ trata tabs se existirem
      .replace(/(\\t)/g, '  ')
      // 3️⃣ limpa espaços extras por linha
      .split('\n')
      .map((line) => line.trim())
      .join('\n')
      .trim();
  }
}
